import classes from '../../../Schreibtisch.module.css';
import _moment from 'moment';
import { Fragment, useState } from 'react';
import {
  Accordion,
  Button,
  DescriptionList,
  Stack
} from '@efast_public/fjd-component-library';
import { useTranslation } from 'react-i18next';
import {
  PaymentInformationKey,
  paymentInformationMapper
} from '../PaymentModal/PaymentInformation';
import {
  caseDetailsMapper,
  CaseDetailsModel
} from '../../../../../api/models/Case/CaseDetailsModel';
import PaymentModal from '../PaymentModal/PaymentModal';
import BearbeitungsstandBadge from '../../../../shared/BearbeitungsstandBadge/BearbeitungsstandBadge';
import BescheidstatusBadge from '../../../../shared/BescheidstatusBadge/BescheidstatusBadge';

function Metadaten({
  caseDetails
}: {
  readonly caseDetails: CaseDetailsModel;
}): JSX.Element {
  const [openPaymentModal, setOpenPaymentModal] = useState(false);
  const [openCard, setOpenCard] = useState(true);

  const paymentInfo = paymentInformationMapper(caseDetailsMapper(caseDetails));
  const { t } = useTranslation();

  return (
    <Stack direction="column">
      <PaymentModal
        onClose={() => setOpenPaymentModal(false)}
        paymentInformation={paymentInfo}
        isOpen={openPaymentModal}
      />
      <Accordion
        label={
          <h2 style={{ marginTop: '3px', marginLeft: '10px' }}>Metadaten</h2>
        }
        expanded={openCard}
        onChange={() => setOpenCard(!openCard)}
      >
        <div style={{ marginLeft: '10px', marginRight: '10px' }}>
          <div className={classes.collapsibleCardBody}>
            <DescriptionList>
              <DescriptionList.Item
                key={'Empfänger'}
                title={'Empfänger'}
                description={caseDetails.organizationalUnitName}
              />
              <DescriptionList.Item
                key={'Eingang'}
                title={'Eingang'}
                description={_moment
                  .utc(caseDetails?.createdOn)
                  .local()
                  .format('DD.MM.YYYY, HH:mm')}
              />
              <DescriptionList.Item
                key={'Bearbeitungsstand'}
                title={'Bearbeitungsstand'}
                description={
                  <BearbeitungsstandBadge
                    bearbeitungsstand={caseDetails.bearbeitungsstand}
                    fjdBadgeSize={'xs'}
                  />
                }
              />
              <DescriptionList.Item
                key={'Bescheidstatus'}
                title={'Bescheidstatus'}
                description={
                  <BescheidstatusBadge
                    bescheidstatus={caseDetails.bescheidstatus}
                    bearbeitungsstand={caseDetails.bearbeitungsstand}
                    fjdBadgeSize={'xs'}
                  />
                }
              />
              <DescriptionList.Item
                key={'eBescheid'}
                title={'eBescheid'}
                description={
                  caseDetails.isEBescheidConsentGiven
                    ? 'eingewilligt'
                    : 'abgelehnt'
                }
              />
              <DescriptionList.Item
                key={'eidasLevel'}
                title={'Vertrauensniveau'}
                description={
                  caseDetails.eidasLevel
                    ? t(`eidasLevel.${caseDetails.eidasLevel.toLowerCase()}`)
                    : 'unbekannt'
                }
              />
              {caseDetails.isBeschieden ? (
                <DescriptionList.Item
                  key={'Versandweg Bescheid'}
                  title={'Versandweg Bescheid'}
                  description={
                    caseDetails.isPostalisch ? 'postalisch' : 'digital'
                  }
                />
              ) : (
                <Fragment key={'empty-bescheid'} />
              )}
              {paymentInfo?.available() ? (
                <DescriptionList.Item
                  key={'Zahlung'}
                  title={'Zahlung'}
                  description={
                    <Button
                      variant="primary-text"
                      key={Math.random()}
                      onClick={() => setOpenPaymentModal(true)}
                      data-testid={'payment-information-link'}
                    >
                      <span className={classes.zahlung} id={'zahlung'}>
                        {`${paymentInfo.getValueOf(
                          PaymentInformationKey.STATUS
                        )} `}
                      </span>
                      (Information)
                    </Button>
                  }
                />
              ) : (
                <Fragment key={'empty-zahlung'} />
              )}
            </DescriptionList>
          </div>
        </div>
      </Accordion>
    </Stack>
  );
}
export default Metadaten;
